// Frontend model for the in-app notification hub (bell + dropdown + screen).
// The vocabulary (NotificationType) is imported from the shared backend slice —
// never hardcode type strings here. See docs/notifications/README.md.

import {
  NOTIFICATION_TYPES,
  type NotificationType,
} from "../../../backend/lib/notifications/types.js";
import {
  NOTIFICATION_GROUPS,
  NOTIFICATION_GROUP_OF,
  typesForGroup,
  type NotificationGroup,
} from "../../../backend/lib/notifications/groups.js";
import type { InboxItemDTO } from "../../../backend/lib/notifications/inboxContract.js";

export { NOTIFICATION_TYPES, NOTIFICATION_GROUPS, NOTIFICATION_GROUP_OF, typesForGroup };
export type { NotificationType, NotificationGroup };

/**
 * A persisted inbox row. Aliased to the backend's canonical DTO so the wire
 * shape and the UI can never silently drift (Handoff 3 owns inboxContract.ts).
 */
export type NotificationItem = InboxItemDTO;

/** Paginated inbox response. `nextBefore` is the cursor for the next page. */
export interface NotificationPage {
  items: NotificationItem[];
  nextBefore: string | null;
}

export interface UnreadCountResponse {
  count: number;
}

/** Per-user notification preferences (master push switch + per-type opt-outs). */
export interface NotificationPreferences {
  notificationPush: boolean;
  types: Record<NotificationType, boolean>;
}

/** Partial patch for a preferences update. */
export interface NotificationPreferencesPatch {
  notificationPush?: boolean;
  types?: Partial<Record<NotificationType, boolean>>;
}

/** Timeframe buckets for the notifications screen filter. */
export type NotificationTimeframe = "today" | "week" | "month" | "all";

export function isUnread(item: NotificationItem): boolean {
  return item.readAt === null;
}
